export default __webpack_public_path__ + "static/media/S-038.5325346a.png";